import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

/**
 * Platform i18n.
 *
 * Default language is English. The browser-language detector promotes Spanish
 * automatically when the visitor's device is set to es-* (covers Mexican
 * customers without forcing them to find a toggle). Their manual choice via
 * the header toggle wins and persists to localStorage (and to their user
 * profile via the backend the next time they call /api/user/me, if we wire
 * that up later).
 *
 * Key naming convention: dot-namespaced ("lobby.jump_in", "auth.sign_in").
 * Use t('namespace.key') everywhere in JSX. Interpolation uses {{var}}.
 */
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
        },
        fallbackLng: 'en',
        supportedLngs: ['en', 'es'],
        // Don't translate every locale — keep things simple
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'app_lang',
        },
        interpolation: {
            escapeValue: false, // React handles XSS escaping
        },
        react: {
            useSuspense: false, // Avoid an extra <Suspense> wrapper in App.js
        },
    });

export default i18n;
